import type { LicenseStatus } from '@directus/license';
import * as z from 'zod/v4-mini';

export type { LicenseStatus } from '@directus/license';

export const LICENSE_STATUSES = ['active', 'grace', 'locked'] as const satisfies readonly LicenseStatus[];

export const LicenseStatusSchema = z.enum(LICENSE_STATUSES);

/** License section of `/system/info`. `null` fields mean no/unknown license. */
export interface LicenseInfo {
	status: LicenseStatus | null;
	expiresAt: number | null;
	renewsAt: number | null;
	gracePeriod: number | null;
}
